import type { BlogPostComment } from '@types'

import useDateTime from '@hooks/client/useDateTime'

import styles from './comment.module.scss'

export default function Comment({ data }: { data: BlogPostComment }): JSX.Element {
  const dayjs = useDateTime()
  return (
    <div className={styles.comment}>
      <div className={styles.header}>
        <p className={styles.username}>{data.username}</p>
        <span>{dayjs(data.timeStamp).fromNow()}</span>
      </div>
      <p className={styles.body}>{data.body}</p>
    </div>
  )
}
